import { render, staticRenderFns } from "./IconVirement.vue?vue&type=template&id=87d67d60&"
import script from "./IconVirement.vue?vue&type=script&lang=js&"
export * from "./IconVirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports